<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery" :filters="false">
        <template slot="btns" v-if="permission('/content/app/add')">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增版本</el-button>
        </template>
        <template slot="columns">
            <el-table-column label="版本号" align="center" prop="versionCode"></el-table-column>
            <el-table-column label="版本名称" align="center" prop="versionName"></el-table-column>
            <el-table-column label="包类型" align="center" prop="platform">
                <template slot-scope="{ row }">
                    {{ row.platform == 1 ? 'Android' : 'iOS' }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140"
                v-if="permission('/content/app/edit') || permission('/content/app/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/content/app/edit')" :underline="false" type="primary"
                        @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/content/app/delete')" :underline="false" type="danger"
                        @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/content/app";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            deviceTypes: []
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/content/app/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/content/app/form", query: { id: row.id } });
        },
        handleDelete(row) {
            this.$confirm("确定删除该版本吗？", "提示", { type: "warning" }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    }
};
</script>